import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Dialog from "./Dialog"

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({

    error: {
        color: "red"
    }
}));





export default function CrearUsuario(props) {
    ////////// estilos ///////////////
    const classes = useStyles();

    ///////////////// variables ////////////////
    const callback = props.callback;

    


    return (
        <div>

            {callback.msg &&
                <h5 className={classes.error}>{callback.msg}</h5>
            }
            {callback.status===200 &&
                <h5 style={{color:"#4caf50"}}>Su dispositivo fue actualizado con exito</h5>
            }
        </div>
    );
};


